import { CatalogObject } from '../catalog-object';
import { Link } from '../link';

export type LayerType = 'PointCloud' | 'VectorLayer' | 'RasterLayer' | 'LayerGroup';
export enum LayerTypeEnum {
    pointCloud = 'PointCloud',
    vectorLayer = 'VectorLayer',
    rasterLayer = 'RasterLayer',
    layerGroup = 'LayerGroup',
}
export interface Layer extends CatalogObject {
    /** Category field like (Target,Panorama,Control Point...) */
    category: string | null;
    incomplete: boolean;
    /** layerType field like (PointCloud,VectorLayer,RasterLayer) */
    layerType: LayerType;
    /**Number of projects that use the layer */
    projectsCount: number;
    /**The hypothetical shape of the earth, coinciding with mean sea level and its imagined extension under (or over) land areas. */
    geoid: string | null;
    links: Link[];
    maxx: number;
    maxy: number;
    maxz: number;
    minx: number;
    miny: number;
    minz: number;
    features?: string | null;
    storageUrl?: string | null;
    /**The size it occupies in the storage*/
    size?: number;
    /**Defines somoe transformations to paint on a plane*/
    horizProjectionEPSG: string | null;
    ownerCompanyId?: string;
    uid?: string;
    shared?: boolean;
}

export type LayerReference = Pick<Layer, 'id' | 'layerType'>;

export enum LayerMenuOptions {
    EDIT = 'EDIT',
    DELETE = 'DELETE',
    SHOW_RELATED_PROJECTS = 'SHOW_RELATED_PROJECTS',
    EDIT_PERMISSIONS = 'EDIT_PERMISSIONS',
    FILES_EXPLORER = 'FILES_EXPLORER',
}
